import React, { useEffect, useState } from "react";
import { APP_NAME, APP_PATH } from "../../../constants/environment";
import {
  Box,
  Link,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  ThemeProvider,
} from "@mui/material";
import "../../../translations/i18n";
import { GlobalStoreState } from "../../../store/states/globalStoreState";
import { navigateToUrl } from "single-spa";
import { styles } from "../../../assets/styles/components/molecules/Navigation/menuItemStyle";
import { useLocalStorage } from "../../../hooks/useLocalStorage";
import { useTranslation } from "react-i18next";
import AppTheme from "../../utils/Themes/AppTheme";
import globalStore from "../../../store/globalStore";
import Icon from "../../../assets/images/svg/Menu-price.svg";
import ReactDOM from "react-dom";
import singleSpaReact from "single-spa-react";

const MenuItem = (): JSX.Element => {
  const [openDrawer, setOpenDrawer] = useState<boolean | undefined>(false);
  const { setOnLoadPrices } = useLocalStorage();
  const { t } = useTranslation();

  const handleNavigate =
    (path: string) => (event: React.MouseEvent<HTMLElement>) => {
      event.preventDefault();
      navigateToUrl(`/${path}`);
      setOnLoadPrices("false");
    };

  useEffect(() => {
    let unmounted = false;

    globalStore.SubscribeToGlobalState(
      APP_NAME,
      ({ configuration }: GlobalStoreState) => {
        if (!unmounted) {
          setOpenDrawer(configuration.openDrawer);
        }
      }
    );

    return () => {
      unmounted = true;
    };
  }, []);

  return (
    <ThemeProvider theme={AppTheme}>
      <ListItem
        component={Link}
        data-testid="list-item-link"
        disablePadding
        onClick={handleNavigate(APP_PATH)}
        sx={{ display: "block" }}
      >
        <ListItemButton
          sx={{
            minHeight: 48,
            justifyContent: "initial",
            px: 2.5,
          }}
        >
          <ListItemIcon
            sx={{
              minWidth: 0,
              mr: openDrawer ? 3 : "auto",
              justifyContent: "center",
            }}
          >
            <img alt={"prices"} height={30} src={Icon} width={30} />
          </ListItemIcon>
          <ListItemText
            data-testid="list-item-text"
            primary={t("utils.navigation.label")}
            sx={{ opacity: openDrawer ? 1 : 0 }}
            primaryTypographyProps={{
              sx: styles.itemText,
            }}
          />
        </ListItemButton>
      </ListItem>
    </ThemeProvider>
  );
};

const lifecycles = singleSpaReact({
  React,
  ReactDOM,
  rootComponent: MenuItem,
  errorBoundary(err, errInfo, props) {
    return <Box>error</Box>;
  },
});

export const { bootstrap, mount, unmount } = lifecycles;

export default MenuItem;
